/* Show the Zeel logo wherever the brand name is written */
(function () {
  'use strict';
  var ref = document.querySelector('img[src*="zeel-logo"]');
  if (!ref) return;
  var SRC = ref.currentSrc || ref.src;
  var SKIP = 'script,style,textarea,input,select,option,title,noscript,svg,.rte,.zeel-rte,.zfoot-bar,.zlogo-w,[data-nologo],[contenteditable]';
  var RE = /\b(Zeel|ZEEL)\b/;
  var st = document.createElement('style');
  st.textContent = 'img.zlogo-w{display:inline-block!important;height:.74em!important;width:auto!important;max-width:none;aspect-ratio:auto;vertical-align:baseline;margin:0 .06em!important;padding:0!important;border:0!important;border-radius:0!important;box-shadow:none!important;background:none!important;object-fit:contain!important;flex:none;transform:none!important;animation:none!important}'
    + 'img.zlogo-w.zlogo-light{filter:brightness(0) invert(1)}';
  document.head.appendChild(st);
  function isLight(el) {
    var m = getComputedStyle(el).color.match(/[\d.]+/g);
    return !!m && (+m[0] * 0.299 + +m[1] * 0.587 + +m[2] * 0.114) > 170;
  }
  function swap(node) {
    var p = node.parentElement;
    if (!p || !RE.test(node.nodeValue) || p.closest(SKIP)) return;
    var light = isLight(p);
    var parts = node.nodeValue.split(/\b(Zeel|ZEEL)\b/);
    var frag = document.createDocumentFragment();
    parts.forEach(function (t, i) {
      if (i % 2) {
        var img = document.createElement('img');
        img.className = 'zlogo-w' + (light ? ' zlogo-light' : '');
        img.src = SRC; img.alt = 'Zeel'; img.decoding = 'async';
        frag.appendChild(img);
      } else if (t) frag.appendChild(document.createTextNode(t));
    });
    p.replaceChild(frag, node);
  }
  function run(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) if (RE.test(n.nodeValue)) list.push(n);
    list.forEach(swap);
  }
  run(document.body);
  var busy = false;
  new MutationObserver(function (muts) {
    if (busy) return;
    busy = true;
    muts.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (n) {
        if (n.nodeType === 3) swap(n);
        else if (n.nodeType === 1 && !n.classList.contains('zlogo-w')) run(n);
      });
    });
    busy = false;
  }).observe(document.body, { childList: true, subtree: true });
})();

/* Veg / Non-veg marks open the matching products, except where the mark belongs to one product */
(function () {
  'use strict';
  var OWN = '.zcard,.card,.zcol,.zsnack,.zmi,.zrt-item,.zab-list,.zgw,.zmt,[data-gallery],.zvn,a,button';
  var st = document.createElement('style');
  st.textContent = 'a.zvn-go{display:inline-flex;align-items:center;gap:inherit;color:inherit;text-decoration:none;cursor:pointer}a.zvn-go:hover{color:#5b3fa0}li:has(>a.zvn-go){transition:background .2s ease,translate .2s ease}li:has(>a.zvn-go):hover{background:#ebe4f7;translate:0 -2px}';
  document.head.appendChild(st);
  [].forEach.call(document.querySelectorAll('.zmark-veg,.zmark-non'), function (m) {
    if (m.parentElement.closest(OWN)) return;
    var kind = m.classList.contains('zmark-veg') ? 'veg' : 'nonveg';
    var a = document.createElement('a');
    a.className = 'zvn-go';
    a.href = '/#' + kind;
    a.setAttribute('aria-label', kind === 'veg' ? 'See Veg products' : 'See Marine products');
    a.addEventListener('click', function () { setTimeout(apply, 40); });
    var box = m.parentElement;
    if (box.tagName === 'LI' && box.querySelectorAll('.zmark').length === 1) {
      while (box.firstChild) a.appendChild(box.firstChild);
      box.appendChild(a);
    } else {
      box.replaceChild(a, m);
      a.appendChild(m);
    }
  });
  function apply() {
    var k = location.hash.slice(1);
    if (k !== 'veg' && k !== 'nonveg' && k !== 'nosugar') return;
    var b = document.querySelector('[data-zfilter-bar] button[data-zfilter="' + k + '"]');
    var sec = document.getElementById('range');
    if (!b || !sec) return;
    if (b.getAttribute('aria-pressed') !== 'true') b.click();
    setTimeout(function () { sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
  }
  window.addEventListener('hashchange', apply);
  setTimeout(apply, 250);
})();
